// Static variables from hidden inputs
const bundleProductId = document.querySelector("#byb-product-id-hidden-input").value;
const bundleProductHandle = document.querySelector("#byb-product-handle-hidden-input").value;
const bundleFrequencyPlanIds = document.querySelector("#byb-plan-ids-hidden-input").value.split(",");
const bundleProductVariantIds = document.querySelector("#byb-variant-ids-hidden-input").value.split(",");

const MOST_POPULAR_FREQUENCY_ID = bundleFrequencyPlanIds[0];
const BEST_VALUE_QUANTITY_ID = bundleProductVariantIds[0];

let frequencyPlanId = bundleFrequencyPlanIds[0];
let productQuantityId = bundleProductVariantIds[0];
let bundleQuantitySize = 0;
let bundlePriceSavings = 0;
let compareAtBundlePrice = 0;
let bundlePrice = 0;

let bundle = {
  externalProductId: bundleProductId,
  externalVariantId: productQuantityId,
  selections: []
};

// Bundle info elements
const selectOptions = document.querySelectorAll(".byb-select-option");
const productFilterElement = document.querySelector("#byb-product-select-filter");
const colorFilterElement = document.querySelector("#byb-color-select-filter");
const lengthFilterElement = document.querySelector("#byb-length-select-filter");

// Bundle product item elements
const productItems = document.querySelectorAll(".byb-product-item");
const emptyProductMessageElement = document.querySelector(".empty-products-list-message");
const variantSizeOptions = document.querySelectorAll(".variant-size-option");
const quantityControlButtons = document.querySelectorAll(".byb-qty-control");

// Cart info elements
const cartContainer = document.querySelector(".byb-cart-container");
const selectedWeftsCountElement = document.querySelector("#selected-wefts-count");
const weftsQuantityElement = document.querySelector("#wefts-quantity");
const weftsQuantityInfoElement = document.querySelector("#wefts-quantity-info");
const bundleFrequencyElement = document.querySelector("#bundle-frequency");
const selectedProductListElement = document.querySelector("#byb-selected-product-list");

const bundlePriceContainer = document.querySelector(".byb-price-container");
const bundleCompareAtPriceElement = document.querySelector("#byb-bundle-compare-at-price").querySelector("span");
const bundlePriceElement = document.querySelector("#byb-bundle-price").querySelector("span");

const addToBagButton = document.querySelector("#byb-add-to-cart-btn");
const mobileCartDropdownButton = document.querySelector(".byb-cart-container-dropdown-button-mobile");

// Apply all filters setting into product list
function applyFilters() {
  let anyItemVisible = false;

  productItems.forEach((productItem) => {
    let showItem = true;

    if (productFilterElement.value !== "all" && productItem.dataset.productName !== productFilterElement.value) {
      showItem = false;
    }

    if (colorFilterElement.value !== "all" && productItem.dataset.colorName !== colorFilterElement.value) {
      showItem = false;
    }

    if (lengthFilterElement.value !== "all" && productItem.dataset.sizeName.match(/\d+/g).join('') !== lengthFilterElement.value.match(/\d+/g).join('')) {
      showItem = false;
    }

    if (showItem) {
      productItem.classList.remove("hidden");
      anyItemVisible = true;
    } else {
      productItem.classList.add("hidden");
    }
  });

  if (anyItemVisible) {
    emptyProductMessageElement.classList.add("hidden");
  } else {
    emptyProductMessageElement.classList.remove("hidden");
  }
}

function updateProductQuantity() {
  let productListHTML = "";
  let compareAtPrice = 0;
  let totalPrice = 0;
  const bundleSelections = [];

  // Update bundle selections
  productItems.forEach((productItem) => {
    const productQuantity = Number(productItem.querySelector(".byb-qty-input").value);

    if (productQuantity > 0) {
      productListHTML += `<p>${productItem.dataset.variantTitle} x ${productQuantity}</p>`;

      const frequencyIndex = bundleFrequencyPlanIds.indexOf(frequencyPlanId);
      const sellingPlanIds = productItem.dataset.sellingPlanIds.split(",");

      bundleSelections.push({
        collectionId: productItem.dataset.collectionId,
        externalProductId: productItem.dataset.productId,
        externalVariantId: productItem.dataset.variantId,
        quantity: productQuantity,
        sellingPlan: sellingPlanIds[frequencyIndex]
      });

      const productPrice = Number(productItem.dataset.variantPrice) * productQuantity

      compareAtPrice += productPrice;
      totalPrice += productPrice - (productPrice * Number(productItem.dataset.variantDiscountValues.split(",")[frequencyIndex]) / 100);
    }
  });

  selectedProductListElement.innerHTML = productListHTML || "<p>Select products to see the price.</p>";
  bundle = {
    ...bundle,
    externalVariantId: productQuantityId,
    selections: bundleSelections
  };

  // Update the bundle price
  const selectedBundleSize = bundleSelections.reduce((total, selection) => total + selection.quantity, 0);

  selectedWeftsCountElement.innerHTML = selectedBundleSize;
  bundleCompareAtPriceElement.innerHTML = (compareAtPrice / 100).toFixed(2);
  bundlePriceElement.innerHTML = (totalPrice / 100).toFixed(2);

  if (selectedBundleSize > 0) {
    bundlePriceContainer.classList.remove("hidden");
  } else {
    bundlePriceContainer.classList.add("hidden");
  }

  // Update the bundle UI
  addToBagButton.disabled = selectedBundleSize != bundleQuantitySize;

  productItems.forEach((productItem) => {
    productItem.querySelector(".byb-qty-control[data-action='increase']").disabled = (selectedBundleSize >= bundleQuantitySize);
  });
}

function resetBundle() {
  bundle = {
    ...bundle,
    selections: []
  };

  selectedProductListElement.innerHTML = "<p>Select products to see the price.</p>";
  selectedWeftsCountElement.innerHTML = "0";
  bundleCompareAtPriceElement.innerHTML = "0.00";
  bundlePriceElement.innerHTML = "0.00";
  bundlePriceContainer.classList.add("hidden");
  addToBagButton.disabled = true;

  productItems.forEach((productItem) => {
    productItem.querySelector(".byb-qty-input").value = 0;
    productItem.querySelector(".byb-qty-control[data-action='decrease']").disabled = true;
    productItem.querySelector(".byb-qty-control[data-action='increase']").disabled = false;
  });
}

function toggleMobileCartDropdown() {
  if (cartContainer.classList.contains("opened")) {
    cartContainer.classList.remove("opened");
  } else {
    cartContainer.classList.add("opened");
  }
}

async function addToCart() {
  addToBagButton.disabled = true;
  addToBagButton.classList.add("btn--loading");

  const cartItems = await recharge.bundle.getDynamicBundleItems(bundle, bundleProductHandle);
  const cartData = { items: cartItems };

  await fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(cartData),
  });

  const selectedBundleSize = bundle.selections.reduce((total, selection) => total + selection.quantity, 0);

  document.querySelector(".header-cart_item-count").textContent = Number(document.querySelector(".header-cart_item-count").textContent) + selectedBundleSize;
  addToBagButton.classList.remove("btn--loading");

  document.querySelector(".added-notification_product-title").innerHTML = "Wefts Bundle";
  document.querySelector(".added-notification").classList.add("active");

  setTimeout(() => document.querySelector(".added-notification").classList.remove("active"), 6000);
  resetBundle();
}

document.addEventListener("DOMContentLoaded", () => {
  selectOptions.forEach((option) => {
    const span = document.createElement("span");
    const planId = option.dataset.planId;

    if (planId === MOST_POPULAR_FREQUENCY_ID) {
      span.innerHTML = "Most Popular";
      option.append(span);
    }

    if (planId === BEST_VALUE_QUANTITY_ID) {
      span.innerHTML = "Best Value";
      option.append(span);
    }

    if (planId === frequencyPlanId) option.classList.add("selected");
    if (planId === productQuantityId) {
      option.classList.add("selected");
      weftsQuantityElement.innerHTML = weftsQuantityInfoElement.innerHTML = bundleQuantitySize = Number(option.dataset.quantity);
      bundlePrice = Number(option.dataset.price);
    }

    option.addEventListener("click", () => {
      if (option.dataset.selectType === "frequency") {
        frequencyPlanId = option.dataset.planId;
        bundleFrequencyElement.innerHTML = option.dataset.frequencyName;

        selectOptions.forEach((selectOption) => {
          if (selectOption.dataset.selectType === "frequency") {
            selectOption.classList.remove("selected");
          }
        });
        option.classList.add("selected");
      } else if (option.dataset.selectType === "size") {
        productQuantityId = option.dataset.planId;
        weftsQuantityElement.innerHTML = weftsQuantityInfoElement.innerHTML = bundleQuantitySize = Number(option.dataset.quantity);
        bundlePrice = Number(option.dataset.price);

        selectOptions.forEach((selectOption) => {
          if (selectOption.dataset.selectType === "size") {
            selectOption.classList.remove("selected");
          }
        });
        option.classList.add("selected");
      }
    })
  });

  variantSizeOptions.forEach((option) => {
    option.addEventListener("click", () => {
      const parentSizeSelect = option.closest(".variant-size-select");
      parentSizeSelect.querySelectorAll(".variant-size-option").forEach((childOption) => {
        childOption.classList.remove("selected");
      });
      option.classList.add("selected");
    });
  });

  quantityControlButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const quantityInput = button.closest(".byb-variant-quantity-container").querySelector(".byb-qty-input");

      if (button.dataset.action === "increase") {
        quantityInput.value = parseInt(quantityInput.value) + 1;
        button.closest(".byb-variant-quantity-container").querySelector(".byb-qty-control[data-action='decrease']").disabled = false;
      } else {
        if (parseInt(quantityInput.value) > 0) {
          quantityInput.value = parseInt(quantityInput.value) - 1;

          if (Number(quantityInput.value) === 0) {
            button.closest(".byb-variant-quantity-container").querySelector(".byb-qty-control[data-action='decrease']").disabled = true;
          }
        }
      }
    });
  });

  productFilterElement.addEventListener("change", applyFilters);
  colorFilterElement.addEventListener("change", applyFilters);
  lengthFilterElement.addEventListener("change", applyFilters);

  mobileCartDropdownButton.addEventListener("click", toggleMobileCartDropdown);
  addToBagButton.addEventListener("click", addToCart);

  window.addEventListener("click", (event) => {
    if (event.target.id !== "byb-add-to-cart-btn") {
      updateProductQuantity();
    }
  });
});